<template>
  <section class="sec04">
    <div class="inner">
      <!--공지사항-->
      <div class="home_notice">
        <h1 class="h1">
          <span>공지사항</span>
        </h1>
        <router-link tag="button" to="/news/notice" class="more_btn">
          <span>더보기</span>
        </router-link>
        <news-list :items="items" :pageInfo="pageInfo" @view="fnView" />
      </div>
      <!--//공지사항-->
    </div>
  </section>
</template>

<script>
import NewsList from '@/components/pages/news/list/index'

export default {
  name: 'main-notice-index',
  components: { NewsList },
  data: function() {
    return {
      params: {
        page: 1,
        limit: 5,
        noticeType: 1,
        searchText: ''
      },
      items: [],
      pageInfo: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function(page = 1) {
      this.params.page = page
      const res = await this.$NewsSvc.getListBoxNotice(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    fnView: function(item) {
      this.$router.push({
        path: '/news/notice/view',
        query: { noticeNo: item.noticeNo }
      })
    }
  }
}
</script>

<style scoped></style>
